import { useAtomValue } from 'jotai';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, DropdownMenu, Flex, Text } from '@dodilio/ui-design-lib';
import { signedInAtom } from '../session';
import { signInToFinish, signOut } from '../auth';
import { leaveSignup } from '../leave';
import { Avatar } from './ContinueAs';

/**
 * Top right of every signup page: who is signed in (with the way on and out),
 * else the switch between signing up and signing in.
 */
export const TopBar = () => {
    const signedIn = useAtomValue(signedInAtom);
    const { pathname } = useLocation();
    const navigate = useNavigate();

    if (signedIn) {
        const { who, org } = signedIn;
        return (
            <DropdownMenu.Root>
                <DropdownMenu.Trigger>
                    <button type="button" className="topChip" aria-label={`Signed in as ${who.email ?? 'you'}`}>
                        <Avatar who={who} size={28} />
                        <span className="topChipText">
                            <Text size="1" weight="medium" truncate>{who.email ?? who.name}</Text>
                            {org && <Text size="1" color="gray" truncate>{org}</Text>}
                        </span>
                    </button>
                </DropdownMenu.Trigger>
                <DropdownMenu.Content align="end">
                    {org && <DropdownMenu.Item onSelect={() => leaveSignup()}>Go to the console</DropdownMenu.Item>}
                    <DropdownMenu.Item color="red" onSelect={() => { void signOut(); }}>Sign out</DropdownMenu.Item>
                </DropdownMenu.Content>
            </DropdownMenu.Root>
        );
    }
    if (pathname === '/') {
        return (
            <Flex align="center" gap="2">
                <Text size="2" color="gray" className="topHint">Have an account?</Text>
                <Button size="2" variant="soft" radius="full" onClick={() => { void signInToFinish(); }}>Sign in</Button>
            </Flex>
        );
    }
    if (pathname === '/reset') {
        return <Button size="2" variant="soft" radius="full" onClick={() => navigate('/')}>Sign up</Button>;
    }
    return null;
};

/** Under the sign-up form: what continuing agrees to. */
export const TermsLine = () => (
    <Text as="p" size="1" color="gray" align="center" style={{ marginTop: 16 }}>
        By continuing you agree to Dodil&apos;s{' '}
        <a href="https://dodil.io/legal/terms" target="_blank" rel="noopener noreferrer">Terms</a> and{' '}
        <a href="https://dodil.io/legal/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
    </Text>
);
